import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";

const API_URL = process.env.REACT_APP_LOCALHOST_URL + "/api/auth/";

export const login = createAsyncThunk('auth/login', async (loginObj) => {
  console.log("U P:", loginObj.username, loginObj.password);
  const username = loginObj.username;
  const password = loginObj.password;
  const response = await axios.post(API_URL + "signin", {
      username,
      password,
    });
    console.log(response);

    return response.data;
  });

  export const reloadUser = createAsyncThunk('auth/reloadUser', async (loginObj) => {
    const response = await axios.get(API_URL + "reloadUser",  { headers: AuthHeader.authHeader() });
      console.log(response);
  
      return response.data;
    });

    export const reloadSubsite = createAsyncThunk('auth/reloadSubsite', async (loginObj) => {
      const response = await axios.get(API_URL + "reloadSubsite",  { headers: AuthHeader.authHeader() });
        console.log(response);
    
        return response.data;
      });
  
    export const loadSubsite = createAsyncThunk('subsite/get', async (subsiteId) => {
      const response = await axios.get(process.env.REACT_APP_LOCALHOST_URL + "/api/subsite/" + subsiteId);
        console.log(response);
        return response.data;
      });

      
  export const register = createAsyncThunk('auth/register', async (registerObj) => {
    console.log(registerObj);
    const response = await axios.post(API_URL + "register", {
        registerObj
      });
      console.log(response);
  
      return response.data;
    });

    export const confirm = createAsyncThunk('auth/confirm', async (id) => {
      console.log(id);
      const response = await axios.post(API_URL + "confirm", {
          regId: id
        });
        console.log(response);
    
        return response.data;
      });
      
  export const getRegistration = createAsyncThunk('auth/register', async (id) => {
    const response = await axios.get(API_URL + "register/" + id);
      console.log(response);
      return response.data;
    });

  export const getRetailSubsite = createAsyncThunk('subsite/retail', async (subsiteId) => {
      const response = await axios.get(process.env.REACT_APP_LOCALHOST_URL + "/api/subsite/" + subsiteId);
        console.log(response);
        return response.data;
      });
    
  export const getUser = state => state.auth.user;
  export const getRegisterUser = state => state.auth.registerUser;
  export const getSubsite = state => state.auth.currentSubsite;
  export const getSubsiteStatus = state => state.auth.subsiteStatus;
  export const getRetailStatus = state => state.auth.retailStatus;
  export const isLoggedIn = state => state.auth.isLoggedIn;
  export const message = state => state.auth.error;
  export const isAdmin = state => state.auth.isAdmin;
  export const isSuperAdmin = state => state.auth.isSuperAdmin;
  export const isSupervisor = state => state.auth.isSupervisor;
  export const isManager = state => state.auth.isManager;

  const initialState = {
    isLoggedIn: false, 
    isAdmin: false, 
    isSuperAdmin: false, 
    isSupervisor: false, 
    isManager: false, 
    user: {},
    registerUser: {},
    currentSubsite: {},
    status: 'idle',
    subsiteStatus: 'idle',
    retailStatus: 'idle',
    error: null
  };

  const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
      logout(state, action) {
        console.log("IS LOGGING OUT", action.payload);
        state.user = {};
        state.isLoggedIn = false;
        state.isAdmin = false;
        state.isSuperAdmin = false;
        state.isSupervisor = false;
        state.isManager = false;
        localStorage.clear();
        sessionStorage.clear();
        state.error = "";
        window.location.href = "/login?message=" + action.payload;
      },
      notFound(state, action) {
        window.location.href = "/notfound";
      },
      setSubsite(state, action) {
        state.currentSubsite = action.payload;
        state.subsiteStatus = 'subsite' + action.payload.id;
      },
      updateEmailPrefs(state, action) {
        console.log("UPDATE EMAIL PREFS", action.payload);
        state.user.email_pref = {"allEmails": action.payload.allEmails, "poEmails" : action.payload.poEmails, "dailyEmails": action.payload.dailyEmails};
      }
    },
    extraReducers(builder) {
      builder
        .addCase(login.pending, (state, action) => {
          if(state.error != null) state.error = null;
          state.status = 'loading'
        })
        .addCase(login.fulfilled, (state, action) => {
          state.status = 'succeeded'
          // Add any fetched posts to the array
          console.log("USER LOGGED IN", action.payload);
          state.user = action.payload.user;
          for(var i=0; i<action.payload.user.roles.length; i++) {
            if(action.payload.user.roles[i] === "ROLE_SUPER") {
              state.isSuperAdmin = true;
              state.isAdmin = true;
            } else if(action.payload.user.roles[i] === "ROLE_SITEADMIN") {
              state.isAdmin = true;
            } else if(action.payload.user.roles[i] === "ROLE_SUPERVISOR") {
              state.isSupervisor = true;
            } else if(action.payload.user.roles[i] === "ROLE_MANAGER") {
              state.isManager = true;
            }
          }
          console.log("CURRENT SUBSITE FROM AUTH", action.payload.user.currentSubsite);
          state.currentSubsite = action.payload.user.currentSubsite;
          state.isLoggedIn = true;
        })
        .addCase(login.rejected, (state, action) => {
          console.log("USER REJECTED", action);
          state.status = 'failed';
          state.error = "User or password incorrect";
        })
        .addCase(reloadUser.pending, (state, action) => {
          if(state.error != null) state.error = null;
          state.status = 'loading'
        })
        .addCase(reloadUser.fulfilled, (state, action) => {
          state.status = 'succeeded'
          // Add any fetched posts to the array
          console.log("USER LOGGED IN", action.payload);
          state.user = action.payload.user;
          for(var i=0; i<action.payload.user.roles.length; i++) {
            state.isSuperAdmin = false;
            state.isAdmin = false;
            state.isSupervisor = false;
            state.isManager = false;
            if(action.payload.user.roles[i] === "ROLE_SUPER") {
              state.isSuperAdmin = true;
              state.isAdmin = true;
            } else if(action.payload.user.roles[i] === "ROLE_SITEADMIN") {
              state.isAdmin = true;
            } else if(action.payload.user.roles[i] === "ROLE_SUPERVISOR") {
              state.isSupervisor = true;
            } else if(action.payload.user.roles[i] === "ROLE_MANAGER") {
              state.isManager = true;
            }
          }
          state.isLoggedIn = true;
        })
        .addCase(reloadUser.rejected, (state, action) => {
          console.log("USER REJECTED", action);
          state.status = 'failed';
          state.error = null;
        })
        .addCase(reloadSubsite.pending, (state, action) => {
          if(state.error != null) state.error = null;
          state.status = 'loading'
        })
        .addCase(reloadSubsite.fulfilled, (state, action) => {
          state.currentSubsite = action.payload.subsite;
          state.status = 'succeeded';
        })
        .addCase(reloadSubsite.rejected, (state, action) => {
          console.log("RELOAD SUBSITE REJECTED", action);
          state.status = 'failed';
          state.error = null;
        })
        .addCase(getRetailSubsite.pending, (state, action) => {
          if(state.error != null) state.error = null;
          state.retailStatus = 'loading'
        })
        .addCase(getRetailSubsite.fulfilled, (state, action) => {
          state.retailStatus = 'succeeded'
          console.log("USER LOGGED IN", action.payload);
          state.currentSubsite = action.payload;
        })
        .addCase(getRetailSubsite.rejected, (state, action) => {
          console.log("USER REJECTED", action);
          state.retailStatus = 'failed';
          state.error = "Subsite is not Retail";
        })
        .addCase(loadSubsite.pending, (state, action) => {
          if(state.error != null) state.error = null;
        })
        .addCase(loadSubsite.fulfilled, (state, action) => {
          state.subsiteStatus = 'succeeded';
          console.log("RELOAD SUBSITE", action.payload);
          state.currentSubsite = action.payload;
        })
        .addCase(loadSubsite.rejected, (state, action) => {
          state.subsiteStatus = 'failed';
          state.error = "Subsite is not reloaded";
        })
        .addCase(getRegistration.fulfilled, (state, action) => {
          state.registerUser = action.payload.user;
          console.log("GET REGISTER USER", state.registerUser);
        })
    }
});
  
export const { logout, notFound, setSubsite, updateEmailPrefs } = authSlice.actions;
export default authSlice.reducer;